import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IWorkShift from '../interfaces/IWorkShift';
import Layout from '~/components/Layout';

export default function Create() {
  const { register, handleSubmit, control, setValue: setFormValue } = useForm<IWorkShift>();
  const fields = [
    { name: 'name', type: 'string', required: true },
    { name: 'work_hours', type: 'number', required: true },
    { name: 'rest_hours', type: 'number', required: true },
  ];

  return (
    <Layout marginLayout={true}>
      <CrudCreate
        model="work-shift"
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        messageSuccess="Work shift successfully created!"
        title="Add Work Shift"
        subheader="Add a new work shift"
        setFormValue={setFormValue}
      />
    </Layout>
  );
}